export enum QuestionTypeEnum {
  likert = 'Questions::Likert',
  openEnded = 'Questions::OpenEnded',
}
